import React from 'react';
import classnames from 'classnames';
import styles from './AsidePanel.module.scss';

export interface AsidePanelProps {
  className?: string;
  position: 'left' | 'right';
  animated?: boolean;
  style?: React.CSSProperties;
}

export const AsidePanel: React.FC<React.PropsWithChildren<AsidePanelProps>> = ({
  className,
  position,
  animated = true,
  style,
  children,
}) => {
  return (
    <>
      <div
        style={style}
        className={classnames(
          'h-full',
          styles.container,
          {
            [styles.animated]: animated,
            [styles.positionLeft]: position === 'left',
            [styles.positionRight]: position === 'right',
          },
          className,
        )}
      >
        {children}
      </div>
    </>
  );
};
